<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/moje-oplaty' aria-label='Moje opłaty'>
        Moje opłaty
      </a>
    </li>
    @if (loading()) {
      <li>
        Ładowanie...
      </li>
    } @else {
      <li>
        <a routerLink="../">{{ payment()?.service?.name }}</a>
      </li>
      <li>
        {{ paymentComponent()?.description }}
      </li>
    }
  </app-breadcrumbs>
  <section>
    @if (!loading()) {
      <h2>
        {{ paymentComponent()?.description }}
      </h2>
      <div class="gov-card">
        <div class="gov-card__header">
          Dane do opłaty
        </div>
        <div class="gov-card__body">
          <div class="row mb-2">
            <div class="col-12">
              <app-label label="Nazwa:">
                {{ paymentComponent()?.description }}
              </app-label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-4">
              <app-label label="Stan konta na dzień:">
                {{ currentDate | date }}
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Termin płatności:">
                {{ paymentComponent()?.paymentDate }}
              </app-label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-4">
              <app-label label="Odsetki na dzień:">
                {{ paymentComponent()?.interestOnDay }}
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Odsetki:">
                {{ paymentComponent()?.interest | toNumber | currency }}
              </app-label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <app-label label="Koszty:">
                {{ paymentComponent()?.costs | toNumber | currency }}
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Saldo zobowiązania:">
                {{ paymentComponent()?.value | toNumber | currency }}
              </app-label>
            </div>
          </div>
        </div>
        <div class="gov-card__footer">
          <div class="row">
            <div class="col-12">
              <app-label label="Konto do wpłat:">
                <div class="d-inline-flex align-items-center">
                  @if (payment()?.service?.accountNumber; as accountNumber) {
                    {{ accountNumber }}
                    <button title="Kopiuj numer konta" type="button" class="btn btn-tertiary icon-btn ms-1"
                            [appCopyToClipboard]="accountNumber">
                      <i class='fa fa-copy'></i>
                    </button>
                  } @else {
                    -
                  }
                </div>
              </app-label>
            </div>
            <div class="col-12">
              <app-label label="Identyficator płatnika:">
                @if (payerData()?.identSigid; as identSigId) {
                  {{ identSigId }}
                  <button title="Kopiuj identyficator płatnika" type="button" class="btn btn-tertiary icon-btn ms-1"
                          [appCopyToClipboard]="identSigId">
                    <i class='fa fa-copy'></i>
                  </button>
                }
              </app-label>
            </div>
            <div class="col-md-12 d-flex align-items-center">
              <app-label class="mt-1" label="Łącznie do zapłaty <small>(saldo, odsetki, koszty)</small>:">
                {{ paymentComponent() | itemTotalAmount | currency }}
                <button title="Kopiuj łączną kwotę do zapłaty" type="button" class="btn btn-tertiary icon-btn ms-1"
                        [appCopyToClipboard]="paymentComponent() | itemTotalAmount | currency">
                  <i class='fa fa-copy'></i>
                </button>
              </app-label>
              @if (paymentComponent(); as paymentComponent) {
                <button [disabled]="payClicked || !(paymentComponent | itemTotalAmount)" (click)="goToPay(paymentComponent)" type="button" class="btn btn-primary ms-3">
                  <i class="fa fa-credit-card"></i>
                  Zapłać
                </button>
              }
            </div>
          </div>
        </div>
      </div>
      <br>
      <table class="table table-silver">
        <caption>Historia transakcji</caption>
        <thead>
        <tr>
          <th>
            Data operacji
          </th>
          <th>
            Kwota
          </th>
          <th>
            Strona konta
          </th>
          <th>
            BO
          </th>
          <th>
            Typ
          </th>
          <th>
            Uwagi
          </th>
          <th>
            Numer dokumentu
          </th>
        </tr>
        </thead>
        <tbody>
          @for (item of paymentComponent()?.operations; track $index) {
            <tr>
              <td>
                {{ item?.operationDate || '-' }}
              </td>
              <td>
                {{ item?.operationAmount | toNumber | currency }}
              </td>
              <td>
                {{ item?.operationPage || '-' }}
              </td>
              <td>
                {{ item?.boEntry | join }}
              </td>
              <td>
                {{ item?.operationType }}
              </td>
              <td>
                {{ item?.operationComments || '-' }}
              </td>
              <td>
                {{ item?.decisionNumber || '-' }}
              </td>
            </tr>
          }
        </tbody>
        @if (!paymentComponent()?.operations?.length) {
          <tfoot>
          <tr>
            <td colspan="7" class="no-data">
              Brak danych do wyświetlenia
            </td>
          </tr>
          </tfoot>
        }
      </table>
    } @else {
      <app-spinner>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    }
  </section>
</app-content>
